import React from "react"
import { Divider, ListSubheader, MenuItem } from "@material-ui/core"
import { useQueryOrganisationTemplates } from "../../data"
import { toId } from "../../utils"
import { OutlinedSelect } from "./OutlinedSelect"

const TemplateOutlinedSelect = ({ allLabel = "Any job template", hasAll = false, ...rest }) => {
  // TODO: limit to 1000 for now, need to implement pagination/virtualization
  const { data: dataActiveRecurring } = useQueryOrganisationTemplates({
    variables: { set: "active-recurring", limit: 1000 },
  })
  const { data: dataActiveAdhoc } = useQueryOrganisationTemplates({ variables: { set: "active-adhoc", limit: 1000 } })
  const { data: dataActiveOneOff } = useQueryOrganisationTemplates({ variables: { set: "active-oneoff", limit: 1000 } })
  const { data: dataActiveTasks } = useQueryOrganisationTemplates({ variables: { set: "active-tasks", limit: 1000 } })
  const { data: dataInactiveRecurring } = useQueryOrganisationTemplates({
    variables: { set: "inactive-recurring", limit: 1000 },
  })
  const { data: dataInactiveAdhoc } = useQueryOrganisationTemplates({
    variables: { set: "inactive-adhoc", limit: 1000 },
  })
  const { data: dataInactiveOneOff } = useQueryOrganisationTemplates({
    variables: { set: "inactive-oneoff", limit: 1000 },
  })
  // const { data: dataInactiveTasks } = useQueryOrganisationTemplates({
  //   variables: { set: "inactive-tasks", limit: 1000 },
  // })

  if (
    !dataActiveRecurring ||
    !dataActiveAdhoc ||
    !dataActiveOneOff ||
    !dataActiveTasks ||
    !dataInactiveRecurring ||
    !dataInactiveAdhoc ||
    !dataInactiveOneOff // ||
    //! dataInactiveTasks
  )
    return null

  const data = [
    ...dataActiveRecurring.organisationTemplates.items,
    ...dataActiveAdhoc.organisationTemplates.items,
    ...dataActiveOneOff.organisationTemplates.items,
    ...dataActiveTasks.organisationTemplates.items,
  ]

  const dataInactive = [
    ...dataInactiveRecurring.organisationTemplates.items,
    ...dataInactiveAdhoc.organisationTemplates.items,
    ...dataInactiveOneOff.organisationTemplates.items,
    // ...dataInactiveTasks.organisationTemplates.items,
  ]

  return (
    <OutlinedSelect label="Job" native={false} {...rest}>
      {!hasAll && <MenuItem value="none">Select job...</MenuItem>}
      {hasAll && <MenuItem value="all">{allLabel}</MenuItem>}
      <Divider />
      {Boolean(data?.length) && <ListSubheader disableSticky>Active</ListSubheader>}
      {data
        ?.sort(({ name: a }, { name: b }) => a.localeCompare(b))
        .map((item) => (
          <MenuItem key={toId(item)} value={toId(item)}>
            {item.name}
          </MenuItem>
        ))}
      <Divider />
      {Boolean(dataInactive?.length) && <ListSubheader disableSticky>Inactive</ListSubheader>}
      {dataInactive
        ?.sort(({ name: a }, { name: b }) => a.localeCompare(b))
        .map((item) => (
          <MenuItem key={toId(item)} value={toId(item)}>
            {item.name}
          </MenuItem>
        ))}
    </OutlinedSelect>
  )
}

export { TemplateOutlinedSelect }
